// @ts-nocheck
//#region react/redux
import React, { Component } from "react"
import Menu, { NestedDropdownMenu } from "react-dd-menu"
//#endregion react/redux

//#region @mui/mui
import SettingsRounded from '@mui/icons-material/SettingsRounded'
import Button from '@mui/material/Button'

import { IconButton } from '@mui/material'
// import SettingsIcon from '@mui/icons-material/Settings'
import Divider from '@mui/material/Divider'
//#endregion @mui/mui

//#region  modules
import { COLOR, PATH } from "../../modules/constants"
import { todaysTrialCode, getUrlTrialDaysLeft } from "../../modules/trialCode"
//#endregion module

import * as api from '../../services/api'
import history from "../../services/history"

export class DeveloperMenu extends Component {

  state = {
    isMenuOpen: false
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  close() {
    if (this.refs.myRef && this.state.isMenuOpen) {
      this.setState({ isMenuOpen: false })
    }
  }

  login() {
    this.setState({ isMenuOpen: false }, () => this.props.login())
  }

  logout() {
    this.setState({ isMenuOpen: false }, () => this.props.logout())
  }

  disconnect() {
    this.setState({ isMenuOpen: false }, () => this.props.disconnect())
  }

  renderButton() {
    const { classes } = this.props

    return (
      <IconButton
        className={classes.rightIcon}
        color="inherit"
        aria-label="open menu"
        data-intro="click to open menu"
        onClick={() => this.toggle()}
        sx={{ mr: 1 }}
      >
        <SettingsRounded fontSize="medium" style={
          {
            verticalAlign: "middle",
            color: COLOR.NAVBAR_TEXT,
          }} />
      </IconButton>
    )
  }

  getExclusionState = () => window.localStorage.plausible_ignore === "true"

  toggleTracking() {
    const exclusionState = this.getExclusionState()

    if (exclusionState) {
      delete window.localStorage.plausible_ignore
      console.log("prevent tracking cookie deleted")
    } else {
      window.localStorage.plausible_ignore = "true"
      console.log("prevent tracking cookie set")
    }
  }

  trialCode() {
    const trialCode = todaysTrialCode()
    // console.log("trial code: " + trialCode)
    const daysLeft = getUrlTrialDaysLeft(trialCode)
  }

  render() {
    const { aiCosts, lse, synopsis } = this.props

    // Added color to warn user in they are not on 'localhost'
    const menuItemStyle = { color: location.hostname !== "localhost" ? COLOR.BAD : COLOR.BLACK }

    const buttonProps = { variant: "menu", style: menuItemStyle }

    const importNestedProps = {
      toggle: <Button  {...buttonProps}>Import</Button>,
    }

    // console.log("isLoggedIn: " + isLoggedIn + ", features: ", features)
    const props = { lse, synopsis }

    return (
      <Menu ref="myRef" isOpen={this.state.isMenuOpen} toggle={this.renderButton()} close={() => this.close()} align="right" >

        {<NestedDropdownMenu {...importNestedProps}  >
          <li><Button {...buttonProps} onClick={() => api.lse.importGoogleSheetsCompanies()}>GoogleSheets Companies</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.importGoogleSheetsAdvisers()}>GoogleSheets Advisers</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.importGoogleSheetsDictionary()}>GoogleSheets Dictionary</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.importFinnhub()}>from Finnhub</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.importCompaniesHouse()}>from Companies House</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.goShopping()}>Go Shopping</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.deduplicatePeople()}>Deduplicate People</Button></li>
          <li><Button {...buttonProps} onClick={() => handleCooking(props)}>Cook Resources</Button></li>
          <li><Button {...buttonProps} onClick={() => meld(props)}>Meld Resources</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.cookNews()}>Cook News</Button></li>
          <Divider />
          <li><Button {...buttonProps} onClick={() => handleImportAll(props)}>All of the above</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.importAll()}>Import All (single api call)</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.importEvents()}>Import Events</Button></li>
          <Divider />
          <li><Button {...buttonProps} onClick={() => api.lse.getAppointments(true)}>Start GetAppointments</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.getAppointments(false)}>Stop GetAppointments</Button></li>
          <Divider />
          <li><Button {...buttonProps} onClick={() => api.lse.startScheduledImport()}>Start Scheduled Import</Button></li>
          <li><Button {...buttonProps} onClick={() => api.lse.stopScheduledImport()}>Stop Scheduled Import</Button></li>
        </NestedDropdownMenu>}

        <Divider />
        <li><Button {...buttonProps} onClick={() => api.lse.validateOfficerIds()}>Validate Officer Ids</Button></li>
        <li><Button {...buttonProps} onClick={() => api.lse.parse350ClubDir()}>Parse 350Club Dir</Button></li>
        <Divider />

        <li><Button {...buttonProps} onClick={() => this.toggleTracking()} >{this.getExclusionState() ? "Tracking blocked: enable" : "Tracking enabled: block"}</Button></li>
        <li><Button {...buttonProps} onClick={() => this.trialCode()} >Trial code</Button></li>

        <Divider />
        <li><Button {...buttonProps} onClick={() => synopsis.revise()} >Revise Synopsis</Button></li>
        <li><Button {...buttonProps} onClick={() => synopsis.get()} >Get Synopsis</Button></li>

        <Divider />
        <li><Button {...buttonProps} onClick={() => aiCosts.collect()} >Collect Costs</Button></li>
        <li><Button {...buttonProps} onClick={() => { this.setState({ isMenuOpen: false }); history.push(`/${PATH.AI_COSTS}`) }} >View Costs</Button></li>
      </Menu>
    )
  }
}

const shop = () => api.lse.goShopping()
const deduplicate = () => api.lse.deduplicatePeople()
const cook = () => api.lse.cookResources()

const meld = ({ lse, synopsis }) => {
  Promise.all([api.lse.meldResources()]).then(() => {
    lse.getCompaniesMeta()
    lse.getApptsMeta()
    lse.getPeopleMeta()
    synopsis.get()
  })
}

const handleImportAll = ({ lse, synopsis }) => {
  const events = () => api.lse.importEvents()
  const companies = () => api.lse.importGoogleSheetsCompanies()
  const advisers = () => api.lse.importGoogleSheetsAdvisers()
  const dictionary = () => api.lse.importGoogleSheetsDictionary()
  const companiesHouse = () => api.lse.importCompaniesHouse()
  const finnhub = () => api.lse.importFinnhub()

  Promise.all([events()]).then(() => {
    Promise.all([companies()]).then(() => {
      Promise.all([finnhub(), companiesHouse(), dictionary(), advisers()]).then(() => {
        Promise.all([shop(),]).then(() => {
          Promise.all([deduplicate(),]).then(() => {
            Promise.all([cook(),]).then(() => {
              meld({ lse, synopsis })
            })
          })
        })
      })
    })
  })
}

const handleCooking = props => {
  Promise.all([cook()]).then(() => meld(props))
}
